// extracted by mini-css-extract-plugin
module.exports = {"articleCard":"ArticlesListing_articleCard__ai97W","buttonWrapper":"ArticlesListing_buttonWrapper__5yCTz","articlesWrapper":"ArticlesListing_articlesWrapper__naiJC"};